import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  z-index: 60;

  button {
    border: 0;
    cursor: pointer;
    font-family: "Inter", sans-serif;
  }

  svg[role="img"] {
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
    display: block;
    height: 20px;
    overflow: hidden;
    width: 28px;
  }

  .language-trigger {
    align-items: center;
    background: rgba(24, 26, 32, 0.76);
    border-radius: 999px;
    color: var(--color-neutral-white);
    display: flex;
    gap: 8px;
    height: 40px;
    padding: 0 12px;
  }

  .language-menu {
    background: var(--color-neutral-darkness);
    border: 1px solid var(--color-neutral-dark);
    border-radius: 12px;
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.32);
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 150px;
    padding: 6px;
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
  }

  .language-menu button {
    align-items: center;
    background: transparent;
    border-radius: 8px;
    color: var(--color-neutral-white);
    display: flex;
    font-size: 14px;
    font-weight: 700;
    gap: 10px;
    line-height: 20px;
    padding: 8px;
    text-align: left;
    white-space: nowrap;
  }

  .language-menu button:hover,
  .language-menu button.active {
    background: var(--color-neutral-dark);
  }
`;
